import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import SubNavigation from 'components/SubNavigation';
import SubNavigationItem from 'components/SubNavigation/SubNavigationItem';
import { normalizeForumQuery } from 'forumQueries';
import { getForumStatus } from 'selectors';

import './style.scss';

class Forum extends Component {

  componentDidMount() {
    window.dispatchEvent(new Event('resize')); // The Flickity component wouldn't layout properly if this page is opened directly.
  }

  render() {
    return (
      <section className="Forum content-wrapper">
        <SubNavigation>
          <SubNavigationItem isForForum to="/forum?following=true">{__('members.forum.titles.following')}</SubNavigationItem>

          {process.env.FEATURES.liveForums === true
             ? <SubNavigationItem isForForum to="/forum/live">
                 <span className={classnames('dot', {'is-live': this.props.hasRunningLiveThreads})}></span> {__('members.forum.titles.live')}
               </SubNavigationItem>
             : <div />
          }

          <SubNavigationItem isForForum to="/forum?sort=popular" isActive={this.props.isPopularActive}>{__('members.forum.titles.popular')}</SubNavigationItem>
          {process.env.FEATURES.askForums === true
            ? <SubNavigationItem isForForum to="/forum/ask-kooth">{__('members.forum.titles.ask')}</SubNavigationItem>
            : <div />
          }
          <SubNavigationItem isForForum to="/forum/categories">{__('members.forum.titles.categories')}</SubNavigationItem>
          <SubNavigationItem isForForum to="/forum/start-discussion">{__('members.forum.titles.startNew')}</SubNavigationItem>
        </SubNavigation>

        {this.props.children}
      </section>
    );
  }
}

Forum.propTypes = {
  children: PropTypes.element,
  isPopularActive: PropTypes.bool,
  hasRunningLiveThreads: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const { pathname, query } = props.location;
  const normalizedQuery = normalizeForumQuery(query);
  const { hasRunningLiveThreads } = getForumStatus(state);

  return {
    isPopularActive: pathname === '/forum' && normalizedQuery.sort === 'popular',
    hasRunningLiveThreads
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Forum);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/index.js
 **/